/**
 * Policy Search Panel (Phase 5 — Step 5.10).
 *
 * Search local institution policy database.
 */

import React, { useState, useMemo } from 'react';
import { CollapsiblePanel } from '../shared';
import { POLICY_TEMPLATES } from '@/data/policyTemplates';
import type { PolicyTemplate } from '@abs/shared-types';

export function PolicySearchPanel(): React.ReactElement {
  const [query, setQuery] = useState('');
  const [selectedTemplate, setSelectedTemplate] = useState<PolicyTemplate | null>(null);

  const results = useMemo(() => {
    if (!query.trim()) return POLICY_TEMPLATES.slice(0, 10);
    const q = query.toLowerCase();
    return POLICY_TEMPLATES.filter(
      (t: PolicyTemplate) => t.name.toLowerCase().includes(q) || t.description.toLowerCase().includes(q),
    );
  }, [query]);

  return (
    <CollapsiblePanel title="Policy Database" defaultOpen={false}>
      <div className="policy-search">
        <input
          type="search"
          placeholder="Search by name or description..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          aria-label="Search policy database"
        />
        <div className="policy-search__results">
          {results.map((t: PolicyTemplate) => (
            <button
              key={t.id}
              type="button"
              className={`policy-search__result ${selectedTemplate?.id === t.id ? 'policy-search__result--selected' : ''}`}
              onClick={() => setSelectedTemplate(t)}
            >
              <strong>{t.name}</strong>
              <span className="policy-search__desc">{t.description}</span>
            </button>
          ))}
          {results.length === 0 && <p>No matching policies found.</p>}
        </div>
      </div>
    </CollapsiblePanel>
  );
}
